import type {
  DocumentSectionSpec,
  DocumentType,
  StripUnsupportedOptionsResult,
} from '../config';

export const isProtocolTemplate = (
  type?: DocumentType | string | null,
): boolean => type === 'PROTOCOL' || type === 'protocol';

export type DocumentTypeRules = {
  allowCategories: boolean;
  allowOptions: boolean;
  allowFields: boolean;
};

export const getDocumentTypeRules = (
  type?: DocumentType | string | null,
): DocumentTypeRules => {
  const protocol = isProtocolTemplate(type);

  return {
    allowCategories: true,
    allowOptions: protocol,
    allowFields: protocol,
  };
};

/**
 * Drops section options that the document type cannot hold. Callers apply it
 * at every point where sections enter the form (load, type change, import) so
 * the state never carries options the editor does not render.
 */
export const stripUnsupportedOptions = (
  sections: DocumentSectionSpec[],
  type?: DocumentType | string | null,
): StripUnsupportedOptionsResult => {
  if (getDocumentTypeRules(type).allowOptions) {
    return { sections, removedOptions: false };
  }

  const removedOptions = sections.some(
    ({ options }) => (options?.length ?? 0) > 0,
  );
  const strippedSections = sections.map((section) => {
    const { options, ...sectionWithoutOptions } = section;

    return options === undefined ? section : sectionWithoutOptions;
  });

  return { sections: strippedSections, removedOptions };
};

export const getDefaultSectionTemplateType = (
  type?: DocumentType | string | null,
): 'flexible' | 'strict' => (isProtocolTemplate(type) ? 'flexible' : 'strict');
